export default {
    path: '*',
    redirect: { name: 'console' },
}